import { katTranslator } from '../../shared/i18n';

export const strings = {
  // AST String ID: dmusic-Close
  close_button_label: {
    'en-US': 'Close',
    'fr-FR': 'Fermer',
    'de-DE': 'Schließen',
    'nl-NL': 'Sluiten',
    'es-US': 'Cerrar',
    'pl-PL': 'Zamknij',
    'tr-TR': 'Kapat',
    'cs-CZ': 'Zavřít',
    'pt-BR': 'Fechar',
    'zh-TW': '結束',
    'ko-KR': '닫기',
    'he-IL': 'סגירה',
    'sv-SE': 'Stäng',
    'fr-BE': 'Fermer',
    'nl-BE': 'Sluiten',
    'da-DK': 'Luk',
    'ms-MY': 'Tutup',
    'el-GR': 'Κλείσιμο',
    'ar-AE': 'إغلاق',
    'ta-IN': 'மூடுக',
    'te-IN': 'మూసివేయండి',
    'es-ES': 'Cerrar',
    'ja-JP': '閉じる',
    'it-IT': 'Chiudi',
    'pt-PT': 'Fechar',
    'mr-IN': 'बंद करा',
    'es-MX': 'Cerrar',
    'ml-IN': 'അടയ്ക്കുക',
    'bn-IN': 'বন্ধ করুন',
    'hi-IN': 'बंद करें',
    'fr-CA': 'Fermer',
    'kn-IN': 'ಮುಚ್ಚಿ',
  },
};

export default katTranslator(strings);
